const genAnswer = function (qu, value) {
  // 上传的文件列表
  return value.map(file => {
    return  {
      answer: file.url,
      otherAnswer: file.name,
      extendsData: {
        uid: file.uid,
        type: file.type
      }
    }
  })
}

const setAnswer = function (qu, valueMap, otherAnswerMap, extendsDataMap, answerList = []) {
  // 断点续答初始化文件列表
  this.value = answerList.length && answerList.map(answer => {
      return {
        uid: answer.extendsData && answer.extendsData.uid,
        type: answer.extendsData && answer.extendsData.type,
        name: answer.otherAnswer,
        url: answer.answer
      }
  })
}

const answer = {
  genAnswer,
  setAnswer
}

export default answer



// WEBPACK FOOTER //
// ./src/components/editor/UploadFileBox/answer.js